<div class="blank-layout-container justify-content-center">
    <div class="row">
        <div class="col-12 text-center">
            <img src="/assets/images/backgrounds/errorimg.svg" alt="error-bg" />
            <h2 class="auth-title f-w-600">Opps!!! Access Denied.</h2>
            <h6 class="f-s-20 f-w-600 m-b-30">You do not have permission to view this page.</h6>
            <button mat-flat-button color="primary" (click)="backToLogin()">Go back to Home</button>
        </div>
    </div>
</div>